// Recognizable carrier brand colors for the code chip — an owned, trademark-safe alternative to
// hotlinking third-party logos. Approximate brand hues; the chip shows the carrier code.

interface Brand {
  bg: string
  fg: string
}

const BRANDS: Record<string, Brand> = {
  MSC: { bg: '#f7b500', fg: '#141414' },
  MAERSK: { bg: '#42b0d5', fg: '#ffffff' },
  CMA: { bg: '#004b87', fg: '#ffffff' },
  ONE: { bg: '#c724b1', fg: '#ffffff' },
  COSCO: { bg: '#b01e28', fg: '#ffffff' },
  HPL: { bg: '#ff6600', fg: '#ffffff' },
  HMM: { bg: '#00857c', fg: '#ffffff' },
  CNC: { bg: '#ec6608', fg: '#ffffff' },
  ZIM: { bg: '#009e49', fg: '#ffffff' },
  OOCL: { bg: '#e4002b', fg: '#ffffff' },
  EMC: { bg: '#1f7a3d', fg: '#ffffff' },
  EVERGREEN: { bg: '#1f7a3d', fg: '#ffffff' },
  ANL: { bg: '#004b87', fg: '#ffffff' },
}

export function carrierBrand(code: string | null | undefined): Brand {
  if (!code) return { bg: 'rgb(var(--surface-2-rgb))', fg: 'rgb(var(--ink-rgb))' }
  return (
    BRANDS[code.toUpperCase()] ?? { bg: 'rgb(var(--surface-2-rgb))', fg: 'rgb(var(--ink-rgb))' }
  )
}
